var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.917969 21.8418C0.917969 10.1501 10.4031 0.664978 22.0948 0.664978C33.7865 0.664978 43.2716 10.1501 43.2716 21.8418C43.2716 33.5335 33.7865 43.0186 22.0948 43.0186C10.4031 43.0186 0.917969 33.5335 0.917969 21.8418ZM22.0948 3.92295C12.2024 3.92295 4.17594 11.9494 4.17594 21.8418C4.17594 31.7342 12.2024 39.7606 22.0948 39.7606C31.9872 39.7606 40.0136 31.7342 40.0136 21.8418C40.0136 11.9494 31.9872 3.92295 22.0948 3.92295Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.292 15.0111V28.6724C30.292 29.4238 29.6772 30.0386 28.9259 30.0386H24.8275C24.0761 30.0386 23.4613 29.4238 23.4613 28.6724V15.0111C23.4613 14.2598 24.0761 13.645 24.8275 13.645H28.9259C29.6772 13.645 30.292 14.2598 30.292 15.0111ZM20.7291 15.0111V28.6724C20.7291 29.4238 20.1143 30.0386 19.363 30.0386H15.2646C14.5132 30.0386 13.8984 29.4238 13.8984 28.6724V15.0111C13.8984 14.2598 14.5132 13.645 15.2646 13.645H19.363C20.1143 13.645 20.7291 14.2598 20.7291 15.0111Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.336151b7f2e6c775b4d7f3ea46720cfd.svg";
export { ForwardRef as ReactComponent };